module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_6_m.29e1e22efa9ca42ab7b897670e885ed0.png";